import { useEffect, useRef, useState } from "react";

export function useAutoRefresh(initialMinutes = 1) {
  const [enabled, setEnabled] = useState(false);
  const [intervalMin, setIntervalMin] = useState(initialMinutes);
  const [countdown, setCountdown] = useState(0);
  const [refreshKey, setRefreshKey] = useState(0);

  const timerRef = useRef(null);

  useEffect(() => {
    if (!enabled) {
      if (timerRef.current) clearInterval(timerRef.current);
      timerRef.current = null;
      setCountdown(0);
      return;
    }

    const total = intervalMin * 60;
    setCountdown(total);

    if (timerRef.current) clearInterval(timerRef.current);

    timerRef.current = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          setRefreshKey(k => {
            return k + 1;
          });
          return total;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [enabled, intervalMin]);

  function manualRefresh() {
    setRefreshKey(k => {
      return k + 1;
    });
    if (enabled) setCountdown(intervalMin * 60);
  }

  return {
    enabled,
    setEnabled,
    intervalMin,
    setIntervalMin,
    countdown,
    refreshKey,
    manualRefresh,
  };
}
